import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StudentNoteModel, NoteStatisticsFilter } from 'src/app/_models/academic/notes/NoteModels';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class NotesService {
  private url: string;
  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}`;
  }

  getStudents(classId: number, sectionId: number, sectionSubjectId: number) {
    const queryString = `classId=${classId}&sectionId=${sectionId}&sectionSubjectId=${sectionSubjectId}`;
    return this.http.get(`${this.url}Notes/GetStudents?${queryString}`);
  }
  getStudentsNoteSummary(classId: number, sectionId: number, sectionSubjectId: number,date:string) {
    let queryString = `classId=${classId}&sectionId=${sectionId}`;
    if(sectionSubjectId)
     queryString += `&sectionSubjectId=${sectionSubjectId}`;
     if(date)
     queryString  +=`&date=${date}`;
    return this.http.get(`${this.url}Notes/GetStudentsNoteSummary?${queryString}`);
  }

  getStudentsWithNotes(classId, sectionId, dateFilter: string, sectionSubjectId?: number) {
    dateFilter = moment(dateFilter).toISOString();
    let queryString = `classId=${classId}&sectionId=${sectionId}&dateFilter=${dateFilter}`;
    if (sectionSubjectId) queryString = queryString + `&sectionSubjectId=${sectionSubjectId}`;

    return this.http.get(`${this.url}Notes/GetStudentsWithNotes?${queryString}`);
  }

  AddNote(studentNoteModel: StudentNoteModel) {
    return this.http.post(`${this.url}Notes/AddNote`, studentNoteModel);
  }
  GetStudentsNote(studentNoteModel) {
    return this.http.get(
      `${this.url}Notes/GetStudentsNote?classId=${studentNoteModel.classId}&sectionId=${studentNoteModel.sectionId}&sectionSubjectId=${
        studentNoteModel.sectionSubjectId ? studentNoteModel.sectionSubjectId : ''
      }&startDate=${studentNoteModel.startDate ? studentNoteModel.startDate : ''}&endDate=${
        studentNoteModel.endDate ? studentNoteModel.endDate : ''
      }`
    );
  }
  GetAllNote(
    pageSize: number,
    pageIndex: number,
    classId: number,
    sectionId: number,
    sectionSubjectId: number = null,
    startDate: string = '',
    endDate: string = '',
    noteTypeId: number = null
  ) {
    return this.http.get(`${this.url}Notes/GetAllNote/${pageSize}/${pageIndex}?noteTypeId=${
      noteTypeId ? noteTypeId : ''
    }&classId=${classId}&sectionId=${sectionId}
      &sectionSubjectId=${sectionSubjectId ? sectionSubjectId : ''}
      &startDate=${startDate}&endDate=${endDate}`);
  }
  GetNoteForStudent(studentId: string, sectionSubjectId: number, startDate: string = '', endDate: string = '') {
    return this.http.get(
      `${this.url}Notes/GetNoteForStudent?studentId=${studentId}&sectionSubjectId=${
        sectionSubjectId ? sectionSubjectId : ''
      }&startDate=${startDate}&endDate=${endDate}`
    );
  }
  GetStudentsByNote(noteId: number) {
    return this.http.get(`${this.url}Notes/GetStudentsByNote/${noteId}`);
  }
  UpdateNote(noteId: number, noteMessage: string) {
    return this.http.put(`${this.url}Notes/UpdateNote`, { noteId, noteMessage });
  }
  RemoveStudentNote(studentId: string, noteId: number) {
    return this.http.delete(`${this.url}Notes/RemoveStudentNote/${noteId}/${studentId}`);
  }
  RemoveNote(noteId: number) {
    return this.http.delete(`${this.url}Notes/RemoveNote/${noteId}`);
  }
  getNotesStatistics(noteStatisticsFilter: NoteStatisticsFilter) {
    return this.http.post(`${this.url}Notes/GetNotesStatistics`, noteStatisticsFilter);
  }
}
